import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=4ceab65a"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"
import style0 from "./Page.vue?vue&type=style&index=0&id=4ceab65a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports